<template>
	<div class="p-grid">
		<div class="p-col-12">
			<project-widget></project-widget>
		</div>	
		<div class="p-col-12">
				<FATabs></FATabs>
		</div>		
		<div class="p-col-12">
			<div class="card">
				<entities-grid 
					:filters="filters"
					:columns="columns"
					:entityName="'staff'"
					:datakey="'id'"
					:title="'Team Members'"
					:dialogType="'TeamMemberDialog'"
					:canAdd="module.canAdd"
					:canEdit="module.canEdit"
					:canDelete="module.canDelete"
					:findElementIndex="findElementIndex"
					:canDeleteFunction="canDeleteFunction"
					:module="module"
				></entities-grid>
			</div>

		</div>
		
	</div>
		<div class="p-col-12">
			<comment :module="'staff'"></comment>
		</div>	


</template>

<script>
import EntitiesGrid from '../components/EntitiesGrid.vue'
import { mapGetters } from 'vuex'

export default {
  components: { EntitiesGrid },
	data() {
		return {
			selectedProjects: null,
			filters: [],
			submitted: false,
			comments: "",
			loading: true,
			columns: [
				{field: 'firstName', header: 'First Name', sortable: true},
				{field: 'lastName', header: 'Last Name', sortable: true},
				{field: 'isPrimaryInvestigator', header: 'Primary Investigator', sortable: true, hidden: true},
				{field: 'category', header: 'Category'},                
				{field: 'specialization', header: 'Specialization', sortable: true},
				{field: 'remunerationStatus', header: 'Remuneration Status', sortable: true},
				{field: 'gender', header: 'Gender', sortable: true},
				{field: 'amendmentStatus', header: 'Amendment status', isAmendmentStatus: true}
				
			],
			title: "Team Members",
			module: null,
	
		}
	},
	methods: {
		formatCurrency(value) {
			if(value)
				return value.toLocaleString('en-US', {style: 'currency', currency: 'USD'});
			return;
		},
		exportCSV() {
			this.$refs.dt.exportCSV();
		},
        findElementIndex(arr, obj) {
            return arr.findIndex(x => x.id == obj.id )
        },	
		filterMembers(x) {
			return !x.isPrimaryInvestigator
		},
		canDeleteFunction(x) {
			return !x.isPrimaryInvestigator
		},
    },
	computed: {
		...mapGetters(["getModuleSetup"])
	},
	created() {
		this.module = this.getModuleSetup("staff")
	}		     
}
</script>

<style scoped lang="scss">
	.table-header {
		display: flex;
		justify-content: space-between;
	}

	.product-image {
		width: 100px;
		box-shadow: 0 3px 6px rgba(0, 0, 0, 0.16), 0 3px 6px rgba(0, 0, 0, 0.23);
	}

	.p-dialog .product-image {
		width: 150px;
		margin: 0 auto 2rem auto;
		display: block;
	}

	.confirmation-content {
		display: flex;
		align-items: center;
		justify-content: center;
	}

	.product-badge {
		border-radius: 2px;
		padding: .25em .5rem;
		text-transform: uppercase;
		font-weight: 700;
		font-size: 12px;
		letter-spacing: .3px;

		&.status-instock {
			background: #C8E6C9;
			color: #256029;
		}

		&.status-outofstock {
			background: #FFCDD2;
			color: #C63737;
		}

		&.status-lowstock {
			background: #FEEDAF;
			color: #8A5340;
		}
	}

	::v-deep(.p-toolbar) {
		flex-wrap: wrap;
		.p-button {
			margin-bottom: .25rem;
		}
	}
</style>
